import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import MarketingLayout from "@/components/marketing/MarketingLayout";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import TeacherTraining from "@/pages/TeacherTraining";
import ExamPrep from "@/pages/ExamPrep";
import Consultation from "@/pages/Consultation";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Checkout from "@/pages/Checkout";
import AuthCallback from "@/pages/AuthCallback";

import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import MyCourses from "@/pages/dashboard/MyCourses";
import Assignments from "@/pages/dashboard/Assignments";
import TutorPage from "@/pages/dashboard/TutorPage";
import Enquiries from "@/pages/dashboard/Enquiries";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:slug" element={<CourseDetail />} />
        <Route path="/teacher-training" element={<TeacherTraining />} />
        <Route path="/exam-prep" element={<ExamPrep />} />
        <Route path="/consultation" element={<Consultation />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/checkout/:slug" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />

      <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="courses" element={<MyCourses />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="tutor" element={<TutorPage />} />
        <Route path="enquiries" element={<Enquiries />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
